import { IPage } from '@/types/FmsTypes';
import {
	IVRM2DictDetail,
	IVRM2DictSearchs,
} from '@/views/vrmBill/vrmBillSaleRo/vrmBillSaleRoService';
import { appHttpRequest } from '../../../utils/AppHttpRequest';
import { ISaleRoDetail } from './bmsBillSaleRoType';

class SaleRoService {
	async one(id: string) {
		const apiUrl = `/bcm/sreturn/findById/${id}`;
		return await appHttpRequest.get<ISaleRoDetail>(apiUrl);
	}

	// 客车数据字典
	async pages(searchVo: IVRM2DictSearchs) {
		const apiUrl = '/bcm/base/dict/pages';
		return await appHttpRequest.post<IPage<IVRM2DictDetail>>(apiUrl, searchVo);
	}
}

export const saleRoService = new SaleRoService();
